import gql from 'graphql-tag';

const canceledReturnInvoicesQuery = gql`
  query canceledReturnInvoices(
    $vin: String
    $size: Int
    $offset: Int
    $vra: String
    $dealerNumber: String
    $productFamily: String
  ) {
    canceledReturnInvoices(vin: $vin, offset: $offset, size: $size, vra: $vra, dealerNumber: $dealerNumber, productFamily: $productFamily) {
      id
      guaranteePurchaseId
      returningUsername
      cancellingUsername
      cancelledAt
      invalidatedAt
      returnInitiatedAt
      expirationDate
      reasonForReturn
      vin
      odometer
      purchasePrice
      locationInitials
      returnLocationInitials
      status
      dealerNumber
      productName
      kind
      daysSelected
      milesSelected
    }
  }
`;

export default canceledReturnInvoicesQuery;
